import type { AxiosRequestConfig } from 'axios'

import { orderXClient } from '@/service/client'
import {
  type AddWidgetRequest,
  type ComponentPreference,
  type CreatePageRequest,
  type DeletePageRequest,
  type GetPageLayoutResponse,
  type GetPagesResponse,
  type PageMutationResponse,
  type RemoveWidgetRequest,
  type SaveComponentPreferenceRequest,
  ServerMessage,
  type UpdatePageMetaRequest,
  type UpdateWidgetRequest,
} from '@/types/generated/public_api'

export async function getPages(): Promise<GetPagesResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { getPages: {} })
  return data.getPagesResponse!
}

export async function getPageLayout(pageId: string): Promise<GetPageLayoutResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { getPageLayout: { pageId } })
  return data.getPageLayoutResponse!
}

export async function createPage(req: CreatePageRequest): Promise<PageMutationResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { createPage: req })

  return data.pageMutationResponse!
}

export async function addWidget(req: AddWidgetRequest): Promise<PageMutationResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { addWidget: req })
  return data.pageMutationResponse!
}

export async function updateWidget(req: UpdateWidgetRequest): Promise<PageMutationResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { updateWidget: req }, {
    _skipRateLimitRetry: true,
  } as AxiosRequestConfig & { _skipRateLimitRetry: boolean })
  return data.pageMutationResponse!
}

export async function removeWidget(req: RemoveWidgetRequest): Promise<PageMutationResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { removeWidget: req })
  return data.pageMutationResponse!
}

export async function updatePageMeta(req: UpdatePageMetaRequest): Promise<PageMutationResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { updatePageMeta: req })
  return data.pageMutationResponse!
}

export async function deletePage(req: DeletePageRequest): Promise<PageMutationResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { deletePage: req })
  return data.pageMutationResponse!
}

// Generic per-user preference store (DynamoDB PREF#{componentId} on the backend).
// `preference` is undefined when nothing has been saved for this componentId yet.
export async function saveComponentPreference(
  req: SaveComponentPreferenceRequest
): Promise<ComponentPreference | undefined> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { saveComponentPreference: req })
  return data.componentPreferenceResponse?.preference
}

export async function getComponentPreference(
  componentId: string
): Promise<ComponentPreference | undefined> {
  const { data } = await orderXClient.post<ServerMessage>('/api', {
    getComponentPreference: { componentId },
  })
  return data.componentPreferenceResponse?.preference
}
